/**
 * useBreakpoint — responsive breakpoint detection hook.
 * Returns true when viewport is below 768px (mobile).
 * Sets CSS custom property --is-mobile on document root for CSS-only consumers.
 */

import { useState, useEffect } from "react";

const MOBILE_MAX = 768;

export function useBreakpoint() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < MOBILE_MAX : false,
  );

  useEffect(() => {
    const update = () => {
      const mobile = window.innerWidth < MOBILE_MAX;
      setIsMobile(mobile);
      document.documentElement.style.setProperty("--is-mobile", mobile ? "1" : "0");
    };

    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return { isMobile };
}
